import { memo } from 'react';
import styled from '@emotion/styled';

import { themeFont } from '../../../lib/themeFont';

const Name = styled('h4')`
  line-height: 1;

  ${themeFont('s4')}
`;

interface TimeRangeProps {
  className?: string | undefined;
  formattedTime?: string | null | undefined;
  formattedEndTime?: string | null | undefined;
}

function TimeRange({
  className,
  formattedTime,
  formattedEndTime,
}: TimeRangeProps) {
  return (
    <Name className={className}>
      {formattedTime}
      {formattedTime && formattedEndTime && `–${formattedEndTime}`}
      {!formattedTime && formattedEndTime && `Ends at ${formattedEndTime}`}
    </Name>
  );
}

export default memo(TimeRange);
